import { getBody, server } from '@lib/api/http';

export const fetchBuyerCost = async (
  categoryId: string | number,
  askingPrice: number | string
): Promise<number> => {
  const body = await getBody<{ data?: { buyerCost?: number } }>(
    `${server}v1/costs/calculate-buyer-cost`,
    { categoryId, askingPrice }
  );
  const nextBuyerCost = body?.data?.buyerCost;
  if (typeof nextBuyerCost !== 'number') {
    throw new Error('Unable to calculate inspection fee');
  }
  return nextBuyerCost;
};
